import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import prepareHeaders from '../utils/prepareHeaders'

export const gdapRelationshipsApi = createApi({
  reducerPath: 'gdapRelationships',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    // The active and pending GDAP relationships of one customer tenant of a CSP parent company
    getGdapRelationships: builder.query({
      query: ({ parentCustomerId, externalTenantId }) => ({
        url: `/integration/${parentCustomerId}/gdap-relationships`,
        params: { externalTenantId },
      }),
      transformResponse: (response) => response?.relationships ?? [],
    }),
  }),
})

export const { useGetGdapRelationshipsQuery } = gdapRelationshipsApi
